export default __webpack_public_path__ + "static/media/ladbrokes_au.66caf492.png";